import HotelListItemPlaceholderSmall from '@/app/components/common/HotelListItemPlaceholderSmall'
import HotelsLoadingAnimation from '@/app/components/HotelsLoadingAnimation'
import { XL_BREAKPOINT } from '@/app/constants'
import { useMediaQuery } from '@uidotdev/usehooks'
import classNames from 'classnames'
import { FC } from 'react'
import HotelListItemPlaceholder from './common/HotelListItemPlaceholder'

export interface Props {
	showCount?: boolean
	isListView?: boolean
	page?: number
}

const HotelListPlaceholder: FC<Props> = ({ showCount = true, page, isListView }) => {
	const items = new Array(10).fill(true)
	const isDesktop = useMediaQuery(XL_BREAKPOINT)

	return (
		<div
			className={classNames('hotels-list-placeholder', {
				'px-0': !showCount,
			})}
		>
			<div className="mb-10">
				<HotelsLoadingAnimation />
			</div>
			{showCount ? (
				<div className="hotels-list-placeholder__count"></div>
			) : null}
			{items.map((_, index) => (
				<div key={index} className="mt-5">
					{!isListView && isDesktop ? <HotelListItemPlaceholderSmall /> : <HotelListItemPlaceholder />}
				</div>
			))}
		</div>)
}

export default HotelListPlaceholder
